import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Container } from 'reactstrap'
import { graphql } from 'react-apollo'

import {
  AppAside,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav
} from '@coreui/react'

import me from '../../queries/me.js'
import myPermissions from '../../queries/MyPermissions.js'
// sidebar nav config
// import navigation from '../../_nav'
import navigationAdmin from '../../_navSA'
// routes config
import routes from '../../routes'
import { PERSONAS_TABS, PERSONAS_NAV_URL } from '../../views/Personas/tabs'

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary'
import DefaultAside from './DefaultAside'
// import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader'

// Maps each _navSA.js item's url to the permission key that gates it for
// non-SUPERADMIN roles (see backend RolePermission model / Permisos.js).
// An ARRAY means the item covers several tabbed sections and shows if the role
// can open ANY of them — the four Usuarios tabs keep their own permissions.
const NAV_URL_TO_PERMISSION = {
  '/dashboard': 'NAV_INICIO',
  '/tests': 'NAV_PRUEBAS',
  '/admin-tarjetones': 'NAV_TARJETONES',
  '/goals-management': 'NAV_METAS',
  [PERSONAS_NAV_URL]: PERSONAS_TABS.map((tab) => tab.key),
  '/notifications': 'NAV_NOTIFICACIONES',
}

class DefaultLayout extends Component {
  constructor (props) {
    super(props)
    this.events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress'
    ]
    this.logout = this.logout.bind(this)
  }

  logout () {
    localStorage.removeItem('token')
    this.props.history.push(`/login`)
  }

  render () {
    const { history, data, myPermissions } = this.props
    // console.log(this.props, "props default header")
    if (!localStorage.getItem('token')) {
      history.push(`/login`)
    }
    if (data.loading || (myPermissions && myPermissions.loading)) {
      return <div />
    }

    const user = data.me
    const role = user.role
    const hasTaller = user.hasTaller
    const hasTallerA = user.hasTallerA
    // let role = localStorage.getItem('role');

    // SUPERADMIN always sees every item plus the Permisos page itself (not
    // gated by the permission table — that table only decides what everyone
    // else can see). Every other role's nav is built from the RolePermission
    // toggles instead of a single hardcoded role check, so ADMIN/EVALUATOR
    // (which used to always see the identical full list) and any other role
    // can now be restricted or granted access per-item by SUPERADMIN.
    let navItems = []
    if (role === 'SUPERADMIN') {
      navItems = [
        ...navigationAdmin.items,
        { name: 'Permisos', url: '/permisos', icon: 'icon-lock' },
      ]
    } else {
      const allowedKeys = new Set(
        (myPermissions?.myPermissions || []).filter((p) => p.allowed).map((p) => p.permissionKey)
      )
      navItems = navigationAdmin.items
        .filter((item) => {
          const required = NAV_URL_TO_PERMISSION[item.url]
          return Array.isArray(required)
            ? required.some((key) => allowedKeys.has(key))
            : allowedKeys.has(required)
        })
        // Point the Usuarios item at the first tab this role can actually open.
        // A coordinator has Estudiantes but not Usuarios, so linking to the
        // section's default url would drop them on a tab they cannot see.
        .map((item) => {
          if (item.url !== PERSONAS_NAV_URL) return item
          const firstAllowed = PERSONAS_TABS.find((tab) => allowedKeys.has(tab.key))
          return firstAllowed ? { ...item, url: firstAllowed.path } : item
        })
    }
    const navConfig = { items: navItems }

    return (
      <div className='app'>
        <AppHeader fixed>
          <DefaultHeader data={data} history={history} />
        </AppHeader>
        <div className='app-body'>
          {navItems.length > 0 && (
            <AppSidebar fixed>
              <AppSidebarHeader />
              <AppSidebarForm />
              <AppSidebarNav navConfig={navConfig} {...this.props} />
              <AppSidebarFooter />
            </AppSidebar>
          )}
          <main className='main'>
            {/* <AppBreadcrumb appRoutes={routes}/> */}
            <Container fluid style={{ marginTop: '30px' }}>
              {/* Wraps only the routed page, so a crash inside one view leaves the
                  header and sidebar usable instead of blanking the whole app. */}
              <ErrorBoundary>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component
                          {...props}
                          hasTaller={hasTaller}
                          hasTallerA={hasTallerA}
                        />
                      )}
                    />
                  )
                })}
                <Redirect from='/' to='/login' />
              </Switch>
              </ErrorBoundary>
            </Container>
          </main>
          <AppAside fixed>
            <DefaultAside />
          </AppAside>
        </div>
        {/* <AppFooter>
          <DefaultFooter />
        </AppFooter> */}
      </div>
    )
  }
}

export default graphql(me)(
  graphql(myPermissions, { name: 'myPermissions' })(DefaultLayout)
)
